import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import { BsChevronRight } from "react-icons/bs";
import TermsPrivat from "./TermsPrivat";
import TermsOfUse from "./TermsOfUse";
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';


export default function JoinTerms(props){
    const [modalShow, setModalShow] = React.useState(false);
    const [modal2Show, setModal2Show] = React.useState(false);
    const [checkItems, setCheckItems] = useState([]);
    const { t } = useTranslation();

    const handleSingleCheck = (checked, id) => {
        if (checked) {
          // 단일 선택 시 체크된 아이템을 배열에 추가
          setCheckItems(prev => [...prev, id]);
        } else {
          // 단일 선택 해제 시 체크된 아이템을 제외한 배열 (필터)
          setCheckItems(checkItems.filter((el) => el !== id));
        }
      };

      const handleAllCheck = (checked) => {
        if(checked) {
          // 전체 선택 클릭 시 데이터의 모든 아이템(id)를 담은 배열로 checkItems 상태 업데이트
          const idArray = [];
          for(var i=1; i<5; i++){
            idArray.push(i)
          }         
          setCheckItems(idArray);
        }
        else {
          // 전체 선택 해제 시 checkItems 를 빈 배열로 상태 업데이트
          setCheckItems([]);
        }
      }

      const fn_next = () =>{
        if(checkItems.includes(1) && checkItems.includes(2)){
            props.closeFn();
            props.setTerms(checkItems)
        }else{

        }
      }

    return(
        <div>
            <Header type={props.modal?'modal':'black'}  closeFn={props.closeFn} pageTitle={t(`Message.personal_sign_up_info_input_title`)}/>    
            <div className="loginArea pd20">
                <div>
                    <h3 className="joinMent">{t(`Message.sign_up_agree_msg1`)}<br/>{t(`Message.sign_up_agree_msg2`)}</h3>
                    <ul className="mt40 agreeCheckListWr chkWr">
                        <li className="allAgree">
                            <input type="checkbox" name="terms" id="All" onChange={(e) => handleAllCheck(e.target.checked)}
                        checked={checkItems.length === 4 ? true : false}/>
                            <label htmlFor="All">{t(`Message.sign_up_agree_check_all_agree`)}</label>
                        </li>
                        <li>
                            <input type="checkbox" name="terms" id="term1" 
                            onChange={(e) => handleSingleCheck(e.target.checked, 1)}
                            checked={checkItems.includes(1) ? true : false}
                            />
                            <label htmlFor="term1">{t(`Message.sign_up_agree_check_terms_condition`)}</label>
                            <button onClick={() => setModalShow(true)}><BsChevronRight /></button>
                        </li>
                        <li>
                            <input type="checkbox" name="terms" id="term2" 
                            onChange={(e) => handleSingleCheck(e.target.checked, 2)}
                            checked={checkItems.includes(2) ? true : false} />
                            <label htmlFor="term2">{t(`Message.sign_up_agree_check_privacy_collecting`)}</label>
                            <button onClick={() => setModal2Show(true)}><BsChevronRight /></button>
                        </li>
                        <li>
                            <input type="checkbox" name="terms" id="term3" 
                            onChange={(e) => handleSingleCheck(e.target.checked, 3)}
                            checked={checkItems.includes(3) ? true : false} />
                            <label htmlFor="term3">{t(`Message.sign_up_agree_check_accept_email`)}</label>
                        </li>
                        <li>
                            <input type="checkbox" name="terms" id="term4"
                            onChange={(e) => handleSingleCheck(e.target.checked, 4)}
                            checked={checkItems.includes(4) ? true : false} />
                            <label htmlFor="term4">{t(`Message.sign_up_agree_check_sms_acceptance`)}</label>
                        </li>
                    </ul>
                </div>
                <div to="/Join" className="btn48 orgB cFFF" onClick={fn_next} >{t(`Message.sign_up_agree_button_agree`)}</div>
            </div>



            <Modal 
                className="btModal"
                show={modalShow}
                onHide={() => setModalShow(false)}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <h3 className="modalTitle">{t(`Message.home_tail_service_terms`)}</h3>
                <div className="scrollArea">
                    <TermsOfUse/>
                </div>
                <div className="modalBtnWr">
                    <button onClick={() => setModalShow(false)}>{t(`Message.common_ok`)}</button>
                </div>
            </Modal>




            <Modal
                className="btModal"
                show={modal2Show}
                onHide={() => setModal2Show(false)}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <h3 className="modalTitle">{t(`Message.my_salee_screen_privacy_policy`)}</h3>
                <div className="scrollArea">
                    <TermsPrivat/>
                </div>
                <div className="modalBtnWr">
                    <button onClick={() => setModal2Show(false)}>{t(`Message.common_ok`)}</button>
                </div>
            </Modal>
        </div>
    );
};